import { calculateEffectiveCcDuration } from './tenacity.js';

const CC_IMMUNE_BLOCKED = new Set([
  'stun', 'root', 'slow', 'silence', 'knockup', 'knockback', 'suppression'
]);

export class StatusEffectManager {
  constructor() {
    this.effects = [];
  }

  calculateDuration(type, duration, tenacity = 0) {
    const tenacityPercent = Math.max(0, Number(tenacity) || 0) * 100;
    return calculateEffectiveCcDuration(duration, tenacityPercent, type);
  }

  addEffect(type, duration, value = 0, tenacity = 0) {
    if (this.hasEffect('cc_immune') && CC_IMMUNE_BLOCKED.has(type)) {
      return;
    }
    const effectiveDuration = this.calculateDuration(type, duration, tenacity);
    const existing = this.effects.find(e => e.type === type);

    if (existing) {
      existing.duration = Math.max(existing.duration, effectiveDuration);
      existing.value = Math.max(existing.value, value);
    } else {
      this.effects.push({ type, duration: effectiveDuration, value });
    }
  }

  hasEffect(type) {
    return this.effects.some(e => e.type === type && e.duration > 0);
  }

  getMaxSlow() {
    let maxSlow = 0;
    this.effects.forEach(e => {
      if (e.type === 'slow' && e.duration > 0) {
        maxSlow = Math.max(maxSlow, e.value);
      }
    });
    return maxSlow;
  }

  clearCrowdControl() {
    const cc = new Set(['stun', 'root', 'slow', 'silence']);
    this.effects = this.effects.filter((e) => !cc.has(e.type));
  }

  update(dt) {
    this.effects.forEach(e => {
      e.duration -= dt;
    });
    this.effects = this.effects.filter(e => e.duration > 0);
  }
}
